import React from "react";
import TitleComponent from "@components/TitleComponent";
import ButtonComponent from "@components/ButtonComponent";

/**
 * ActionHeader component - renders the header with title and action buttons
 * @param {function} translate - Translation function
 * @param {function} onCancel - Handler for cancel button click
 * @param {function} onProceed - Handler for proceed button click
 * @param {boolean} isEditing - Whether component is in editing mode
 */
const ActionHeader = ({ translate, onCancel, onProceed, isEditing }) => {
  return (
    <div className="mt-10 flex justify-between items-center">
      <TitleComponent
        text={translate("corrective-action.CorrectivePreview")}
        size="xl"
      />
      <div className="flex justify-between items-center gap-2">
        <ButtonComponent
          withoutborder={true}
          id="action-cancel"
          color="red"
          type="cancel"
          onClick={onCancel}
          ref={null}
          icon={null}
          text={translate("shared.popup-actions.cancel")}
          noTextSwap={true}
          width="fit"
        />
        <ButtonComponent
          withoutborder={true}
          id="action-proceed"
          color="green"
          onClick={onProceed}
          ref={null}
          icon={null}
          disabled={isEditing}
          text={translate("shared.popup-actions.proceed")}
          noTextSwap={true}
          width="fit"
        />
      </div>
    </div>
  );
};

export default ActionHeader;
